import * as React from 'react';
import { Link } from 'react-router-dom';

// ヘッダー用
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Drawer用
import Drawer from '@mui/material/Drawer';
import NotificationsIcon from '@mui/icons-material/Notifications';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CurrencyYenIcon from '@mui/icons-material/CurrencyYen';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { auth, app } from '../firebase';
import { getFunctions, httpsCallable } from "firebase/functions";

import logo from '../images/logo.svg';

export default function Header({ text, return_path }) {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = React.useState(false);
  const [billingLoading, setBillingLoading] = React.useState(false);


  const drawerHandling = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleBillingPortalClick = async () => {
    if (billingLoading) return; // 二重クリック防止
    setBillingLoading(true);
    try {
      const functions = getFunctions(app, 'asia-northeast2');
      // 環境に応じて関数名を切り替え（本番: -j2nr、開発: サフィックスなし）
      const functionName = process.env.REACT_APP_STRIPE_EXTENSION_SUFFIX 
        ? `ext-firestore-stripe-payments-${process.env.REACT_APP_STRIPE_EXTENSION_SUFFIX}-createPortalLink`
        : 'ext-firestore-stripe-payments-createPortalLink';
      const createPortalLink = httpsCallable(functions, functionName);
      const { data } = await createPortalLink({ returnUrl: window.location.origin });
      window.location.assign(data.url);
    } catch (error) {
      console.error(error);
      setBillingLoading(false);
    }
  };

  const handleLogout = () => {
    // ログアウトの確認ダイアログを開く
    setLogoutDialogOpen(true);
  };

  const confirmLogout = () => {
    // ログアウトの確認ダイアログを閉じ、ログアウト処理を実行
    setLogoutDialogOpen(false);
    auth.signOut();
  };

  const cancelLogout = () => {
    // ログアウトの確認ダイアログを閉じる
    setLogoutDialogOpen(false);
  };

  let jsxHeader;

  let drawer = (
    <Drawer anchor="right" open={drawerOpen} onClose={drawerHandling}>
      <Box sx={{ width: 250 }} role="presentation">
        <List>
          <ListItem disablePadding>
            <ListItemButton component={Link} to="/faq">
              <ListItemIcon>
                <HelpOutlineIcon />
              </ListItemIcon>
              <ListItemText primary="よくある質問" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={handleBillingPortalClick} disabled={billingLoading}>
              <ListItemIcon>
                {billingLoading ? <CircularProgress size={24} /> : <CurrencyYenIcon />}
              </ListItemIcon>
              <ListItemText primary={billingLoading ? "読み込み中..." : "決済情報"} />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component={Link} to="/termsOfService">
              <ListItemIcon>
                <TextSnippetIcon />
              </ListItemIcon>
              <ListItemText primary="利用規約" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component={Link} to="/privacyPolicy">
              <ListItemIcon>
                <VerifiedUserIcon />
              </ListItemIcon>
              <ListItemText primary="プライバシーポリシー" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component={Link} to="/noticeList">
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText primary="お知らせ" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="ログアウト" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );

  // メニュー画面のヘッダー
  if (text === 'メニュー') {
    jsxHeader = (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          position="static"
          sx={{
            backgroundColor: '#f9db00',
            color: '#444',
          }}
        >
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="notice"
              component={Link}
              to="/noticeList"
            >
              <NotificationsIcon />
            </IconButton>
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="conekuta"
                sx={{ height: '0.8rem', mb: 1.5 }}
              />
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: "bold",
                  color: "#444",
                  fontSize: "1rem",
                }}
              >
                {text}
              </Typography>
            </Box>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="hamburger-menu"
              onClick={drawerHandling}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        {drawer}
      </Box>
    );
  } else {
    jsxHeader = (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          position="static"
          sx={{
            backgroundColor: '#f9db00',
            color: '#444',
          }}
        >
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="back"
              component={Link}
              to={return_path ? return_path : "/"}
            >
              <ArrowBackIcon />
            </IconButton>
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="conekuta"
                sx={{ height: '0.8rem', mb: 1.5 }}
              />
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: "bold",
                  color: "#444",
                  fontSize: "1rem",
                }}
              >
                {text}
              </Typography>
            </Box>
            <IconButton
              sx={{ visibility: 'hidden' }}
              size="large"
              edge="start"
              color="inherit"
              aria-label="hamburger-menu"
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </Box>
    );
  }

  return (
    <>
      {jsxHeader}
      {/* ログアウト確認ダイアログ */}
      <Dialog open={logoutDialogOpen} onClose={cancelLogout}>
        <DialogContent>
          <Typography>本当にログアウトしますか？</Typography>
        </DialogContent>
        <DialogActions sx={{justifyContent: 'center'}}>
          <Button onClick={cancelLogout}>キャンセル</Button>
          <Button onClick={confirmLogout}>ログアウト</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
